/**
 * Helper: Block class
 * -----------------------------------------------------------------------------
 * Outputs block class based on provided base class.
 *
 * @param {String} blockClass - Block class to add to element.
 * @param {String} element - Element class to add to element.
 * @param {String} modifier - Modifier class to add to element.
 * @returns {String}
 *
 */
export default (blockClass, element, modifier) => {
  if (!blockClass) {
    return '';
  }

  let elementClass = blockClass;

  if (element) {
    elementClass += `__${element}`;
  }

  if (modifier) {
    elementClass += `--${modifier}`;
  }

  return elementClass;
};
